import { render, staticRenderFns } from "./Ratificaciones.vue?vue&type=template&id=723ef4ae"
import script from "./Ratificaciones.vue?vue&type=script&lang=js"
export * from "./Ratificaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('723ef4ae')) {
      api.createRecord('723ef4ae', component.options)
    } else {
      api.reload('723ef4ae', component.options)
    }
    module.hot.accept("./Ratificaciones.vue?vue&type=template&id=723ef4ae", function () {
      api.rerender('723ef4ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/Ratificaciones.vue"
export default component.exports